const HIGHLIGHT_CLASS_NAME = 'highlight-drop-line';
const NOT_ACCEPTABLE_TARGET_CLASS_NAME = 'not-acceptable-target';
const MAKE_LAYOUT_CLASS_NAME = 'make-layout';
const EDGE_CLASS_NAMES = ['top', 'bottom', 'left', 'right'];

let highlightedElement = null;

export function removeLayoutHighlightClasses(element) {

  const classList = element.classList;

  classList.remove(HIGHLIGHT_CLASS_NAME, NOT_ACCEPTABLE_TARGET_CLASS_NAME, MAKE_LAYOUT_CLASS_NAME);

  for (let index = 0; index < EDGE_CLASS_NAMES.length; index++) {
    classList.remove(EDGE_CLASS_NAMES[index]);
  }

}

export function clearLayoutHighlight() {

  if (highlightedElement === null) {
    return;
  }

  removeLayoutHighlightClasses(highlightedElement);
  highlightedElement = null;

}

// A refused drop gets the not-acceptable tint; a drop that creates a layout adds a tint to the line.
export function showLayoutHighlight(drop) {

  clearLayoutHighlight();

  highlightedElement = drop.element;
  highlightedElement.classList.add(HIGHLIGHT_CLASS_NAME);

  if (drop.accepted === false) {
    highlightedElement.classList.add(NOT_ACCEPTABLE_TARGET_CLASS_NAME);
    return;
  }

  highlightedElement.classList.add(drop.edge);

  if (drop.makesLayout === true) {
    highlightedElement.classList.add(MAKE_LAYOUT_CLASS_NAME);
  }

}
